import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { StaticApiService } from '../../features/static-api/staticApi.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';
import { TagsLanguageService } from '../../features/tags-language/tagsLanguage.service';
import { MatDialog } from '@angular/material/dialog';
import { NoDataComponent } from '../../shared/components/no-data/nodata.component';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';
import { ContentLoaderComponent } from '../../shared/components/content-loader-component/contentLoader.component';

@Component({
  selector: 'app-static-page-list',
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    NoDataComponent,
    PermissionDirective,
    ContentLoaderComponent,
  ],
  templateUrl: './static-page-list.component.html',
  styleUrl: './static-page-list.component.scss',
})
export class StaticPageListComponent {
  staticContentList: {
    staticContentId: number;
    key: string;
    langId: number;
    content: string;
  }[] = [];
  readonly dialog = inject(MatDialog);
  public languages: any[] = [];

  public langCode: String = '';
  noData = false;
  loading = false;

  constructor(
    private staticContentService: StaticApiService,
    private router: Router,
    private toastr: ToastrService,
    private sanitizer: DomSanitizer,
    private tagsService: TagsLanguageService
  ) {}

  ngOnInit() {
    this.getAllStaticContent(this.langCode);
  }

  onEditStaticPage(id: any) {
    this.router.navigate([`/info-pages/edit/${id}`]);
  }

  addStaticPage() {
    this.router.navigate(['/info-pages/new']);
  }

  viewStaticPage(id: any) {
    this.router.navigate([`/info-pages/view/${id}`]);
  }

  getLanguages(): void {
    this.tagsService.getLangauges().subscribe({
      next: (res) => {
        if (res?.data) {
          this.languages = res?.data;
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  onLanguageSelect(event: any) {
    this.langCode = event.value;
    this.getAllStaticContent(this.langCode);
  }

  getLanguageName(langId: number): string {
    const lang = this.languages.find((l) => l.id === langId);
    return lang ? lang.name : `Lang ID: ${langId}`;
  }

  getAllStaticContent(lang: any) {
    this.loading = true;
    this.staticContentService.getStaticContents(lang).subscribe({
      next: (res) => {
        const data = res.data || [];
        this.staticContentList = [];

        if (data.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
        data.forEach((item: any) => {
          const staticContentId = item.id;
          const key = item.key;

          item.translations.forEach((trans: any) => {
            this.staticContentList.push({
              staticContentId,
              key,
              langId: trans.langId,
              content: trans.content,
            });
          });
        });
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        console.error(err);
      },
    });
  }
}
